import React from "react"
import truncate from "truncate-html"
import { graphql, Link } from "gatsby"
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const FeaturedPost = (props: any) => {

  // get featured post
  const { featuredPost } = props

  // return null if no featured post is selected
  if (!featuredPost) {
    return null
  }
  // convert date
  const dateStr = new Date(featuredPost?.date).toLocaleDateString()

  // truncate post content
  const description = truncate(featuredPost?.content, {
    length: 160,
    decodeEntities: true,
    stripTags: true,
    reserveLastWord: true,
  })

  const image: any = featuredPost.image

  return (
    <div className="relative px-8 mb-8">
      <div className="flex flex-col sm:flex-row max-w-screen-xl mx-auto pt-8 group">
        <div className="sm:w-1/2 lg:w-2/3 relative">
          <Link
            to={`${featuredPost.path}`}
            className="cursor-pointer"
          >
            <div className="h-64 sm:h-96 relative">              
              {image?.url && (
                <WsrvImage 
                  urlParams={{
                    originURL: image.url,
                    width: image.width,
                    preset: EWsrvTransform.cover4x3
                  }}
                  imgProps={{
                    className: "object-cover object-center rounded-t-lg sm:rounded-none sm:rounded-l-lg w-full h-full",
                    wrapperClassName: "w-full h-full"
                  }}
                />
              )}
            </div>
          </Link>
        </div>
        <div className="sm:w-1/2 lg:w-1/3 bg-gray-100 p-8 border-2 border-t-0 rounded-b-lg sm:rounded-bl-none sm:rounded-r-lg sm:border-t-2 sm:border-l-0 relative">
          <Link
            to={`${featuredPost.path}`}
            className="cursor-pointer"
          >
            <div className="font-display uppercase text-primary-500 text-xs font-bold tracking-widest leading-loose after:content">
              {featuredPost.category?.title ||
                "Uncategorized"}
            </div>
            <div className="border-b-2 border-primary-500 w-8"></div>
            <div className="mt-4 uppercase text-gray-600 italic font-semibold text-xs">
              {dateStr}
            </div>
            <h2 className="font-display text-secondary-500 mt-1 font-black text-2xl group-hover:text-primary-500 transition duration-300">
              {featuredPost.title}
            </h2>
            <p className="text-sm mt-3 leading-loose text-gray-600 font-medium">
              {description}
            </p>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default FeaturedPost

export const query = graphql`
fragment DrupalFeaturedPostContent on DrupalFeaturedPost {
    id
    featuredPost {
      title
      date
      content
      path
      category {
        title
      }
      image {
      	url
        alt
        width
      }      
    }
}
`
